import { motion, AnimatePresence } from 'framer-motion';
import trustpilot from '../assets/logo/Trust-Pilot.svg';
import ChannelCarousel from './channel'
import { useState, useEffect, useCallback } from 'react';
import SEOKeywords from '../components/SEOKeywords';
import CanTicket from '../components/canTicket';


import tv from '../assets/tv.png'


import img1 from '../assets/poster/1.jpg'
import img2 from '../assets/poster/2.jpg'
import img3 from '../assets/poster/3.jpg'
import img4 from '../assets/poster/4.jpg'
import img5 from '../assets/poster/5.jpg'
import img6 from '../assets/poster/6.jpg'
import img7 from '../assets/poster/7.jpg'
import img8 from '../assets/poster/8.jpg'
import img9 from '../assets/poster/9.jpg'
import img10 from '../assets/poster/10.jpg'
import img11 from '../assets/poster/11.jpg'
import img12 from '../assets/poster/12.jpg'
import img13 from '../assets/poster/13.jpg'
import img14 from '../assets/poster/14.jpg'
import img15 from '../assets/poster/15.jpg'
import img16 from '../assets/poster/16.jpg'
import img17 from '../assets/poster/17.jpg'
import img18 from '../assets/poster/18.jpg'
import img19 from '../assets/poster/19.jpg'
import img20 from '../assets/poster/20.jpg'
import img21 from '../assets/poster/21.jpg'
import img22 from '../assets/poster/22.jpg'
import img23 from '../assets/poster/23.jpg'
import img24 from '../assets/poster/24.jpg'
import img25 from '../assets/poster/25.jpg'
import img26 from '../assets/poster/26.jpg'
import img27 from '../assets/poster/27.jpg'
import img28 from '../assets/poster/28.jpg'
import img29 from '../assets/poster/29.jpg'
import img30 from '../assets/poster/30.jpg'
import img31 from '../assets/poster/31.jpg'
import img32 from '../assets/poster/32.jpg'
import img33 from '../assets/poster/33.jpg'
import img34 from '../assets/poster/34.jpg'
import img35 from '../assets/poster/35.jpg'
import img36 from '../assets/poster/36.jpg'
import img37 from '../assets/poster/37.jpg'
import img38 from '../assets/poster/38.jpg'
import img39 from '../assets/poster/39.jpg'
import img40 from '../assets/poster/40.jpg'
import img41 from '../assets/poster/41.jpg'
import img42 from '../assets/poster/42.jpg'
import img43 from '../assets/poster/43.webp'
import img44 from '../assets/poster/44.jpg'
import img45 from '../assets/poster/45.jpg'
import img46 from '../assets/poster/46.png'
import img47 from '../assets/poster/47.webp'
import img48 from '../assets/poster/48.jpg'
import img49 from '../assets/poster/49.jpg'
import img50 from '../assets/poster/50.jpg'
import img51 from '../assets/poster/51.jpg'
import img52 from '../assets/poster/52.jpg'
import img53 from '../assets/poster/53.png'
import img54 from '../assets/poster/54.jpg'
import img55 from '../assets/poster/55.jpg'
import img56 from '../assets/poster/56.webp'
import img57 from '../assets/poster/57.jpg'

export default function Home() {
    // Dados dos filmes com informações
    const movies = [
        { id: 1, image: img1, title: "Airplane Mode", category: "Comédia" },
        { id: 2, image: img2, title: "Stranded with My Mother-in-Law", category: "Reality" },
        { id: 3, image: img3, title: "Sleeping Princess", category: "Comédia" },
        { id: 4, image: img4, title: "Rich in Love 2", category: "Romance" },
        { id: 5, image: img5, title: "Almost Family", category: "Drama" },
        { id: 6, image: img6, title: "Elize Matsunaga: Once Upon a Crime", category: "Documentário" },
        { id: 7, image: img7, title: "Beyond the Universe", category: "Romance" },
        { id: 8, image: img8, title: "7 Prisoners", category: "Drama" },
        { id: 9, image: img9, title: "A Vampire in the Family", category: "Comédia" },
        { id: 10, image: img10, title: "Lady Voyeur", category: "Thriller" },
        { id: 11, image: img11, title: "Latin Blood: The Ballad of Ney Matogrosso", category: "Documentário" },
        { id: 12, image: img12, title: "An Invisible Victim: The Eliza Samudio Case", category: "Documentário" },
        { id: 13, image: img13, title: "Just Short of Perfect", category: "Comédia" },
        { id: 14, image: img14, title: "Rich in Love", category: "Romance" },
        { id: 15, image: img15, title: "Get the Goat", category: "Comédia" },
        { id: 16, image: img16, title: "Fenced In", category: "Comédia" },
        { id: 17, image: img17, title: "Reality Z", category: "Terror" },
        { id: 18, image: img18, title: "Someone Borrowed", category: "Romance" },
        { id: 19, image: img19, title: "Christmas Full of Grace", category: "Romance" },
        { id: 20, image: img20, title: "Double Dad", category: "Comédia" },
        { id: 21, image: img21, title: "The Isabella Nardoni Case", category: "Documentário" },
        { id: 22, image: img22, title: "Burning Betrayal", category: "Thriller" },
        { id: 23, image: img23, title: "Eloá the Hostage: Live on TV", category: "Documentário" },
        { id: 24, image: img24, title: "Outlaw", category: "Ação" },
        { id: 25, image: img25, title: "Vini Jr.", category: "Documentário" },
        { id: 26, image: img26, title: "A Melhor Mãe do Mundo", category: "Comédia" },
        { id: 27, image: img27, title: "A Tragedy Foretold: Flight 3054", category: "Documentário" },
        { id: 28, image: img28, title: "Back to 15", category: "Drama" },
        { id: 29, image: img29, title: "Turn of the Tide", category: "Drama" },
        { id: 30, image: img30, title: "Sintonia", category: "Drama" },
        { id: 31, image: img31, title: "Too Hot to Handle: Brazil", category: "Reality" },
        { id: 32, image: img32, title: "Overhaul", category: "Reality" },
        { id: 33, image: img33, title: "3%", category: "Ficção Científica" },
        { id: 34, image: img34, title: "Senna", category: "Drama" },
        { id: 35, image: img35, title: "Rivers of Fate", category: "Drama" },
        { id: 36, image: img36, title: "Desperate Lies", category: "Drama" },
        { id: 37, image: img37, title: "Caramelo", category: "Drama" },
        { id: 38, image: img38, title: "Brotherhood", category: "Drama" },
        { id: 39, image: img39, title: "Criminal Code", category: "Ação" },
        { id: 40, image: img40, title: "Rulers of Fortune", category: "Drama" },
        { id: 41, image: img41, title: "Toy Story 5", category: "Animação" },
        { id: 42, image: img42, title: "Dexter: Resurrection", category: "Thriller" },
        { id: 43, image: img43, title: "Adolescence", category: "Drama" },
        { id: 44, image: img44, title: "Wednesday", category: "Fantasia" },
        { id: 45, image: img45, title: "American Primeval", category: "Drama" },
        { id: 46, image: img46, title: "Avengers: Doomsday", category: "Ação" },
        { id: 47, image: img47, title: "Fallout", category: "Ficção Científica" },
        { id: 48, image: img48, title: "The Mandalorian and Grogu", category: "Ficção Científica" },
        { id: 49, image: img49, title: "Stranger Things 5", category: "Ficção Científica" },
        { id: 50, image: img50, title: "Fantastic Beasts 4", category: "Fantasia" },
        { id: 51, image: img51, title: "Spider-Man: Brand New Day", category: "Ação" },
        { id: 52, image: img52, title: "The Odyssey", category: "Aventura" },
        { id: 53, image: img53, title: "Mobland", category: "Thriller" },
        { id: 54, image: img54, title: "Jumanji: The Next Level", category: "Aventura" },
        { id: 55, image: img55, title: "Pluribus", category: "Comédia" },
        { id: 56, image: img56, title: "Scream", category: "Terror" },
        { id: 57, image: img57, title: "The Last of Us", category: "Drama" }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = useCallback(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % movies.length);
    }, [movies.length]);

    // Auto-rotação a cada 2 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 2000);

        return () => clearInterval(interval);
    }, [nextSlide]);

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + movies.length) % movies.length);
    };

    const getVisibleMovies = () => {
        const result = [];
        for (let i = 0; i < 3; i++) {
            const index = (currentIndex + i) % movies.length;
            result.push(movies[index]);
        }
        return result;
    };

    return (
        <main className="relative overflow-hidden">

            <div className='container mx-auto px-3 sm:px-5 pt-5 relative z-10'>
                {/* Hero Section */}
                <div className="mb-20 md:mb-24 mt-6 md:mt-8 text-center">

                    <div className="inline-flex items-center gap-3 px-5 py-2 rounded-full bg-white/10 border border-white/20 text-sm uppercase tracking-widest text-yellow-200 mb-6 shadow-lg shadow-yellow-400/10 backdrop-blur">
                        <span className="inline-flex items-center gap-2">
                            ⚽
                            <span>UCL 2026</span>
                        </span>
                        <span className="text-white/80">Premium Edition</span>
                    </div>

                    <h1 className="text-4xl md:text-6xl title-home font-bold mb-6 text-white max-w-4xl mx-auto">
                        Descubra o melhor IPTV em Portugal com <br/> <span className="inline-flex items-center align-middle gap-1"><img src={tv} alt="logo" className='w-20 h-auto' /><span className="text-yellow-400 nimo" style={{ 
                            textShadow: `
                                -1px -1px 0 #000,
                                0 -1px 0 #000,
                                1px -1px 0 #000,
                                -1px 0 0 #000,
                                1px 0 0 #000,
                                -1px 1px 0 #000,
                                0 1px 0 #000,
                                1px 1px 0 #000,
                                -2px -2px 0 #fff,
                                0 -2px 0 #fff,
                                2px -2px 0 #fff,
                                -2px 0 0 #fff,
                                2px 0 0 #fff,
                                -2px 2px 0 #fff,
                                0 2px 0 #fff,
                                2px 2px 0 #fff
                            `
                        }}>4K LIVE</span></span>
                    </h1>

                    <p className="text-lg text-gray-300 font-light mb-10 leading-relaxed max-w-3xl mx-auto px-4">
                    Aproveite a sua subscrição IPTV com qualidade 4K em Smart TV, Android e PC. Aceda a mais de 79 000 canais em direto e 249 000 conteúdos VOD (filmes e séries) sem limitações. Compatível com IPTV Smarters, TiviMate e todos os descodificadores IPTV, com suporte 24/7 para uma experiência fluida.
                    </p>

                    {/* Trustpilot Rating */}
                    <div className="mb-14 flex justify-center items-center">
                        <img src={trustpilot} alt="Trustpilot Rating" className='w-[270px] md:w-[300px]' />
                    </div>

                    <div className="flex items-center justify-center flex-col md:flex-row gap-5">
                        <button
                            onClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })}
                            className="bg-yellow-400 text-black px-6 py-3 rounded-full w-full sm:w-auto text-md font-bold cursor-pointer flex items-center justify-center gap-3 transition-all duration-300 hover:bg-yellow-300 hover:scale-105 hover:shadow-2xl shadow-lg">
                            <span>Começar agora</span>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                        
                        <div className="flex items-center gap-2 text-yellow-400 text-sm font-medium">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" className="text-yellow-400">
                                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={32} d="M315.27 33L96 304h128l-31.51 173.23a2.36 2.36 0 0 0 2.33 2.77h0a2.36 2.36 0 0 0 1.89-.95L416 208H288l31.66-173.25a2.45 2.45 0 0 0-2.44-2.75h0a2.42 2.42 0 0 0-1.95 1"></path>
                            </svg>
                            <span>Ativação Imediata</span>
                        </div>
                    </div>
                    
                    {/* Can ticket */}
                    <div className='flex justify-center items-center'>
                        <CanTicket />
                    </div>
                    
                </div>

                {/* Content Carousel Section */}
                <div className=" mt-0 md:mt-16">
                    <div className="flex items-center justify-between mb-8 mt-0 md:mt-16 relative">
                        <h2 className="text-xl md:text-4xl lg:text-5xl font-bold text-white text-center">VOD & Filmes em Destaque</h2>
                        <div className="flex gap-2 md:gap-4 absolute right-0">
                            <button 
                                onClick={prevSlide}
                                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                            <button 
                                onClick={nextSlide}
                                className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>

                    {/* Carousel Film Container */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 overflow-hidden min-h-[320px]">
                        <AnimatePresence mode='popLayout' initial={false}>
                            {getVisibleMovies().map((movie, index) => (
                                <motion.div
                                    layout
                                    key={movie.id}
                                    initial={{ opacity: 0, scale: 0.8, x: 100 }}
                                    animate={{ opacity: 1, scale: 1, x: 0 }}
                                    exit={{ opacity: 0, scale: 0.8, x: -100 }}
                                    transition={{ 
                                        type: "spring",
                                        stiffness: 300,
                                        damping: 30,
                                        opacity: { duration: 0.2 }
                                    }}
                                    className={`relative group cursor-pointer overflow-hidden rounded-2xl h-64 sm:h-80 lg:h-64 ${index > 0 ? 'hidden lg:block' : ''}`}
                                >
                                    <img
                                        src={movie.image} 
                                        alt={movie.title} 
                                        className="absolute top-0 left-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    />
                                    
                                    {/* Category Badge */}
                                    {movie.category && (
                                        <div className="absolute top-4 left-4 z-10">
                                            <div className="bg-white text-black px-3 py-1 rounded-full text-sm font-semibold">
                                                {movie.category}
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
                                    
                                    {/* Content */}
                                    <div className="absolute bottom-0 left-0 p-4 text-white w-full">
                                        <h3 className="text-lg font-bold mb-1 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                                            {movie.title}
                                        </h3>
                                    </div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>
                </div>
            </div>

            {/* Channel Carousel */}
            <div className="mb-20 w-full">
                <ChannelCarousel/>
            </div>
            <div className="container mx-auto relative z-10 w-full">
                {/* Features */}
                <div className="mt-20 mb-10">
                    <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white text-center mb-16">
                        Por que escolher <span className="text-yellow-400">TV4KLIVE</span> para o seu IPTV?
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
                        {/* Card 1 - 79.000+ Chaînes */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                            <div className="flex flex-col md:flex-row gap-5 md:gap-0 items-center mb-6">
                                <div className="w-[72px] h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mr-0 md:mr-6">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-black" viewBox="0 0 24 24"><g fill="none" fillRule="evenodd"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="currentColor" d="M16.95 4.007a1 1 0 0 0-1.414-1.414l-3.89 3.889a.5.5 0 0 1-.707 0L8.464 4.007A1 1 0 0 0 7.05 5.42l1.414 1.414q.086.086.175.165H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-5.053a4 4 0 0 0 .174-.165zM5 9h14v10H5z"/></g></svg>
                                </div>
                                <h3 className="text-2xl font-bold text-white">79.000+ Canais IPTV</h3>
                            </div>
                            <p className="text-gray-300 leading-relaxed text-lg text-center md:text-left">
                                Uma lista completa de todos os canais europeus e internacionais. Com mais de 79000 canais, oferecemos a melhor lista m3u do mercado para IPTV Smarters e outros leitores.
                            </p>
                        </div>

                        {/* Card 2 - Connexion ultra-rapide */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                            <div className="flex flex-col md:flex-row gap-5 md:gap-0 items-center mb-6">
                                <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mr-0 md:mr-6">
                                    <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-white">Servidores IPTV Estáveis</h3>
                            </div>
                            <p className="text-gray-300 leading-relaxed text-lg text-center md:text-left">
                                Ao contrário de outros fornecedores de IPTV ilegais, a TV4KLIVE utiliza servidores dedicados de alto desempenho. Zapping ultra-rápido em menos de 0,5 segundos e sem cortes durante os jogos.
                            </p>
                        </div>

                        {/* Card 3 - Installation instantanée */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                            <div className="flex flex-col md:flex-row gap-5 md:gap-0 items-center mb-6">
                                <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mr-0 md:mr-6">
                                    <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold text-white">Instalação Fácil</h3>
                            </div>
                            <p className="text-gray-300 leading-relaxed text-lg text-center md:text-left">
                                Configuração simples da sua subscrição IPTV em Smart TV, Caixa Android, Fire Stick ou PC. Fornecemos os códigos Xtream e m3u instantaneamente após a compra.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="hidden">
                    <SEOKeywords />
                </div>
            </div>
        </main>
    )
}